import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useAutoCloseSidebarOnRouteChange(
  collapsed,
  toggleCollapsed
) {
  const location = useLocation();
  useEffect(() => {
    // Only close if sidebar is open (not collapsed) and on mobile
    if (!collapsed && window.innerWidth <= 768) {
      toggleCollapsed();
    }
  }, [location.pathname]);
}
